import { apiClient } from "@/lib/api-client";

export type DataPerBulan = {
  jabatan_fungsional: string;
  jabatan_struktural: string;
  golongan: string;
  kode_unit: string;
  grade_struktural: number;
  grade_fungsional: number;
  nilai_struktural: number;
  nilai_fungsional: number;
  id_status_sekarang: number;
  id_status_pegawai: number;
  status_sekarang?: string;
  status_pegawai?: string;
  total_poin: number;
  rupiah_bersih_30: number | null;
  rupiah_serdos: string;
  cluster: number;
};

export type UnitData = {
  fakultas?: string;
  fkt_kode?: string;
  jrs_kode?: string;
  jurusan?: string;
  prd_kode?: string;
  prodi?: string;
  uk_kode?: string;
};

export type DosenRemunDetailData = {
  niu: string;
  nip: string;
  nama: string;
  tahun: number;
  semester: number;
  last_generated_at: string;
  data_per_bulan: Record<string, DataPerBulan>;
  unit?: UnitData;
  unit_homebase?: UnitData;
  is_penelitian?: boolean;
  is_pengabdian?: boolean;
  details_penelitian?: Array<{
    id: string;
    jenis: string;
    judul: string;
    id_semester: string;
  }>;
  detail_pengabdian?: Array<{
    id: string;
    jenis: string;
    judul: string;
    id_semester: string;
  }>;
  details_pengabdian?: Array<{
    id: string;
    jenis: string;
    judul: string;
    id_semester: string;
  }>;
};

export type DosenRemunDetailResponse = {
  datas: DosenRemunDetailData;
  message: string;
};

export const fetchDosenRemunDetail = async ({
  niu,
  year,
  semester,
  periodeID,
}: {
  niu: string;
  year: number;
  semester: number;
  periodeID?: number | null;
}): Promise<DosenRemunDetailData> => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;

  const params = new URLSearchParams({
    year: year.toString(),
    semester: semester.toString(),
    ...(periodeID && { periodeID: periodeID.toString() }),
  });

  const resData = await apiClient<DosenRemunDetailResponse>(
    `${baseUrl}/api/v1/dosen-remun/${niu}?${params.toString()}`,
    {
      cache: "no-store",
      headers: {
        Accept: "application/json",
      },
    },
  );

  return resData.datas;
};
